import React from "react";
import { connect } from "react-redux";
import * as State from "src/redux/projects/state";
import * as StateCurrentResponses from "src/redux/currentResponses/state";
import * as CurrentReponses from "src/redux/currentResponses";
import PlanDecoration from "src/components/PlanDecoration";
import { Profil } from "src/redux/user";

interface Props {
  proposal: State.ProposalPlanDecoration;
  currentResponses: StateCurrentResponses.CurrentResponse[];
  prestationName: string;
  prestationId: number;
  projectId: number;
  projectName: string;
  profil: Profil;
  handleSubmitProposal: (response: State.GenericalResponse | undefined) => void;
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentProposalResponseForPlanDecoration: (
      proposalUuid: string,
      ressourceId: number,
      payload: State.PayloadPlanDecoration
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseForPlanDecoration(
          proposalUuid,
          ressourceId,
          payload
        )
      ),
    setCurrentProposalResponseType: (
      proposalUuid: string,
      responseType: State.ResponseTypes
    ) =>
      dispatch(
        CurrentReponses.setCurrentProposalResponseType(
          proposalUuid,
          responseType
        )
      ),
    createEmptyPlanDecorationResponse: (
      proposal: State.ProposalPlanDecoration
    ) => dispatch(CurrentReponses.createEmptyPlanDecorationResponse(proposal))
  };
}

type PropsWithMapState = ReturnType<typeof mapDispatchToProps> & Props;
interface State {
  currentIndex: number;
  isLocked: boolean;
  loader: boolean;
}
class PlanDecorationContainerToConnect extends React.Component<
  PropsWithMapState,
  State
> {
  state: State = {
    currentIndex: 0,
    isLocked: this.props.proposal.status !== State.ProposalStatus.Pending,
    loader: false
  };
  componentWillMount() {
    if (!this.getCurrentResponse() && !this.state.isLocked) {
      this.props.createEmptyPlanDecorationResponse(this.props.proposal);
    }
  }
  getCurrentResponse: any = () => {
    const currentResponse = this.props.currentResponses.find(
      r => r.proposalUuid === this.props.proposal.uuid
    );
    return currentResponse;
  };

  handleChangeRessourcePlanDecoration = (
    ressourceId: number,
    response: State.ResponsePlanDecoration
  ) => {
    this.props.setCurrentProposalResponseForPlanDecoration(
      this.props.proposal.uuid,
      ressourceId,
      response.payload as State.PayloadPlanDecoration
    );
  };

  handleSubmitProposalValidated = async (
    payload: State.PayloadPlanDecoration,
    response: State.GenericalResponse
  ) => {
    this.setState({
      loader: true
    });

    this.props.setCurrentProposalResponseType(this.props.proposal.uuid, State
      .ResponseTypes.Validated as State.ResponseTypes);

    await this.props.setCurrentProposalResponseForPlanDecoration(
      this.props.proposal.uuid,
      response.ressourceId,
      payload
    );

    const currentResponse = this.getCurrentResponse();
    // send current response
    this.props.handleSubmitProposal(currentResponse.response);
  };
  handleSubmitProposalPending = async (
    payload: State.PayloadPlanDecoration,
    response: State.ResponsePlanDecoration
  ) => {
    this.setState({
      loader: true
    });
    await this.props.setCurrentProposalResponseForPlanDecoration(
      this.props.proposal.uuid,
      response.ressourceId,
      payload
    );
    const currentResponse = this.getCurrentResponse();

    this.props.handleSubmitProposal(currentResponse.response);
  };
  renderDisplayComponent() {
    return (
      <PlanDecoration
        handleSubmitProposalValidated={this.handleSubmitProposalValidated}
        handleSubmitProposalPending={this.handleSubmitProposalPending}
        handleChangeRessourcePlanDecoration={
          this.handleChangeRessourcePlanDecoration
        }
        profil={this.props.profil}
        isLocked={this.state.isLocked}
        response={this.getCurrentResponse()}
        proposal={this.props.proposal}
        loader={this.state.loader}
      />
    );
  }
  onIndexChange = value => {
    if (value === -1) {
      history.back();
    }
    this.setState({
      currentIndex: value
    });
  };
  render() {
    if (!this.props.proposal) {
      return null;
    }
    return this.renderDisplayComponent();
  }
}

export const PlanDecorationContainer = connect(
  null,
  mapDispatchToProps
)(PlanDecorationContainerToConnect);



// WEBPACK FOOTER //
// ./src/containers/PlanDecorationContainer.tsx